<template>
  <div>
    <!-- <div>
      <div>
        <label for="animalGroup">Animal Groups:</label>
        <div v-for="group in animalGroups" :key="group">
          <input type="checkbox" :id="group" :value="group" v-model="selectedAnimalGroups" />
          <label :for="group">{{ group }}</label>
        </div>
      </div>
    </div> -->
    <div v-if="data.length === 0"></div>
    <div>
      <LineChartComponent :key="chartKey" :chart-data="chartData" :options="chartOptions"  />
    </div>
    <!-- <div>
      <p v-if="hasFilters">Filters are applied</p>
      <p v-else>No filters applied</p>
      <ul>
        <li v-for="(filter, index) in filters" :key="index">{{ filter }}</li>
      </ul>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { defineComponent } from 'vue'
import { Line as LineChartComponent } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement } from 'chart.js'
import api from '@/api'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement
)

export default defineComponent({
  name: 'LeftoversChart',
  components: {
    LineChartComponent
  },
  computed: {
    ...mapGetters('reports', [
      'reportsList',
      'filters',
      'hasFilters'
    ]),
    animalTypes () {
      const types = new Set(this.data.map(item => item.animal_type))
      return Array.from(types)
    },
    animalGroups () {
      const groups = new Set(this.data.map(item => item.group.name))
      return Array.from(groups)
    },
    filteredData () {
      return this.data.filter(item =>
        (this.selectedAnimalType === '' || item.animal_type === this.selectedAnimalType) &&
        (this.selectedAnimalGroups.length === 0 || this.selectedAnimalGroups.includes(item.group.name))
      )
    },
    chartData () {
      const periods = [...new Set(this.filteredData.map(item => item.date_leftover))]
      const sortedPeriods = periods.sort((a, b) => new Date(a) - new Date(b))
      const labels = sortedPeriods

      const groupNames = [...new Set(this.filteredData.map(item => item.group.name))]
      const datasets = []

      groupNames.forEach(groupName => {
        const actualWeightPerHeadData = labels.map(date => {
          const filtered = this.filteredData.filter(item => item.date_leftover === date && item.group.name === groupName)
          const weightPerHead = filtered.reduce((acc, item) => {
            return acc + ((item.fact_weight - item.fact_leftover) / item.animal_count)
          }, 0)
          return Number(weightPerHead.toFixed(2))
        })

        const factWeightData = labels.map(date => {
          const filtered = this.filteredData.filter(item => item.date_leftover === date && item.group.name === groupName)
          const factWeight = filtered.reduce((acc, item) => {
            return acc + (item.fact_weight / item.animal_count)
          }, 0)
          return Number(factWeight.toFixed(2))
        })

        datasets.push({
          label: `${groupName} - Кг/гол`,
          data: actualWeightPerHeadData,
          // backgroundColor: this.randomColor(),
          borderColor: this.randomColor(),
          borderWidth: 2,
          tension: 0.4
        })

        datasets.push({
          label: `${groupName} - Кг/гол факт`,
          data: factWeightData,
          // backgroundColor: this.randomColor(),
          borderColor: this.randomColor(),
          borderWidth: 2,
          tension: 0.4
        })
      })

      return { labels, datasets }
    },
    chartOptions () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true
          },
          tooltip: {
            callbacks: {
              label: function (tooltipItem) {
                const value = tooltipItem.raw
                return `${value.toFixed(2)} 'кг' ${tooltipItem.label}`
              }
            }
          }
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Дні (Період)'
            },
            ticks: {
              autoSkip: false
            }
          },
          y: {
            title: {
              display: true,
              text: 'Вага (кг)'
            },
            beginAtZero: true
          }
        }
      }
    }
  },
  data () {
    return {
      data: [],
      selectedAnimalType: '',
      selectedAnimalGroups: [],
      chartKey: 0,
      flatColors: [
        'rgba(26, 188, 156, 1)',
        'rgba(46, 204, 113, 1)',
        'rgba(52, 152, 219, 1)',
        'rgba(155, 89, 182, 1)',
        'rgba(52, 73, 94, 1)',
        'rgba(241, 196, 15, 1)',
        'rgba(230, 126, 34, 1)',
        'rgba(231, 76, 60, 1)',
        'rgba(236, 240, 241, 1)',
        'rgba(149, 165, 166, 1)'
      ],
      query: {
        farm: this.$route.params.farm_id,
      }
    }
  },
  mounted () {
    this.loadLeftovers()
  },
  methods: {
    ...mapActions('reports', [
      'applyFilters',
      'resetFilters'
    ]),
    async loadLeftovers () {
      const params = this.query
      try {
        const { data, errors } = await api.leftovers.list(params)
        if (!errors) {
          this.data = data
        }
      } catch (error) {
        console.log(error)
      }
    },

    randomColor () {
      const randomIndex = Math.floor(Math.random() * this.flatColors.length)
      return this.flatColors[randomIndex]
    }
  },
  watch: {
    filters (newData) {
      if (newData.planned_on_before && newData.planned_on_after) {
        this.query.date_before = newData.planned_on_before
        this.query.date_after = newData.planned_on_after
      }

      if (newData.group) {
        this.query.group = newData.group
      }

      if (newData.animal_type) {
        this.query.animal_type = newData.animal_type
      }

      this.loadLeftovers()
    },

    data () {
      // Trigger a re-render of the chart by updating a key
      this.chartKey = this.chartKey + 1
    }
  }
})
</script>
